module.exports = __webpack_public_path__ + "img/2023-03-18-ms-atelier-banner.2f1cd33.jpg";